import React, {useState, Fragment, useEffect} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import {dispatch, tcp} from '../../../io'
import { Ref, cache, getConfig, getRow, copy } from '../../../global'
import { Toast } from '../../master/toast'
const ID = 'album'
Ref[ID] = {}
export const Album = prop => {
  const {albumI, u, master, cookie} = prop.master
  const {db} = prop
  const pk = prop.table?.pk
  const verb = prop.row?.verb
  if (verb=='default') return null
  const p = {
    style: {
      margin: '5px',
      padding: '5px',
    },
    onChange: e => {
      const album = e.target.value
      console.log(ID, album, prop.albumChange)
      if (pk<0) debugger
      // const net = {debug: ID, buffer: {media: {[db]: {album}}}}
      const net = {buffer: {[cookie.home]: {media: {[db]: {album}}}}}
      // if (!prop.albumChange) debugger
      // net.debug = ID
      tcp(net)
      // prop.setTable({album, init: prop.table.init})
      // if (prop.setAlbum)
      prop.setAlbum(album)
      // IO[ID]
    },
  }
  if (verb=='delete') p.disabled = true
  return (
    <div>
      <div style={{width: '40%', display: 'inline-block', textAlign: 'right'}}>
        <label style={{margin: '10px', color: vw.THEME}}>
          {albumI}
        </label>
      </div>
      <div style={{width: '50%', display: 'inline-block', textAlign: 'left'}}>
        <select {...p}>
        {
          _.FILE_.reduce((acc, v) => {
            acc.push(
              <option
                value={v}
                key={v}
              >
                {master[v].i}
              </option>
            )
            return acc
          }, [])
        }
        </select>
      </div>
    </div>
  )
}
Album.ID = ID
export default Album
